<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="d-flex">
          <v-icon color="#95A1EC"> $effluentsGrantingBase </v-icon>
          <span class="text-title pl-2">Outorgas de Efluentes emitidas pelo IAT</span>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12" class="mt-2">
          <v-icon class="mr-2" size="16" color="white" style="height: 24px; width: 24px; border-radius: 50%; background-color: #69d7a3;">icon-infohidro-bacia</v-icon>
          <span v-if="location" class="pt-1" style="font-size: 16px;">{{ location.text }}</span>
          <span v-else class="pt-1" style="font-size: 16px;">Estado do Paraná</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="9" xl="9">
        <v-card dark class="primary darken-1" style="border-radius: 6px" height="100%">
          <v-card-title>
            <span class="text-title-card pr-4">
              Carga DBO Solicitada Diária (t/ano)</span>
            <v-spacer v-if="this.hasDataGrantingEffluentsDBO"></v-spacer>
            <v-menu v-if="this.hasDataGrantingEffluentsDBO" offset-y>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" outlined color="secondary lighten-1" class="pl-2">
                  <span class="text-export-card pl-1">{{ optionListSelected.text }}</span>
                  <v-icon color="secondary lighten-1">mdi-chevron-down</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item @click="setItem(item)" v-for="(item, i) in optionsList" :key="i"
                  style="cursor: pointer; border: 1px solid #95a1ec">
                  <span class="text-list-item">{{ item.text }}</span>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-menu v-if="this.hasDataGrantingEffluentsDBO" left offset-y min-width="100">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" text>
                  <v-icon color="secondary lighten-1">mdi-export-variant</v-icon>
                  <span class="text-export-card pl-1">Exportar gráfico</span>
                </v-btn>
              </template>
              <v-list class="py-4" dense>
                <v-list-item @click="printChart(null)">
                  <span>Imprimir gráfico</span>
                </v-list-item>
                <v-list-item link @click="exportChart('image/png', null)">
                  <v-list-item-content>
                    <span>Baixar imagem PNG</span>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item link @click="exportChart('image/jpeg', null)">
                  <v-list-item-content>
                    <span>Baixar imagem JPEG</span>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item link @click="exportChart('image/svg+xml', null)">
                  <v-list-item-content>
                    <span>Baixar imagem SVG</span>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item link @click="exportChart('application/pdf', null)">
                  <v-list-item-content>
                    <span>Baixar documento PDF</span>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item link @click="exportCSV(null)">
                  <v-list-item-content>
                    <span>Baixar documento CSV</span>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item link @click="exportXLS(null)">
                  <v-list-item-content>
                    <span>Baixar documento XLS</span>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-card-title>
          <v-card-text v-show="hasDataGrantingEffluentsDBO">
            <div id="chartCardGrantingEffluents"></div>
          </v-card-text>
          <v-card-text v-if="!hasDataGrantingEffluentsDBO">
            <span class="textNoData">
              Sem dados para SIA.
            </span>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="12" md="12" lg="3" xl="3">
        <v-card dark height="100%" class="primary darken-1" style="border-radius: 6px">
          <div class="pa-4 d-flex">
            <div>
              <span class="text-title-card">Estimativa entre <br />
                cargas DBO</span>
            </div>
            <v-spacer></v-spacer>
            <v-menu left offset-y min-width="100">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" text>
                  <v-icon color="secondary lighten-1">mdi-export-variant</v-icon>
                  <span class="text-export-card pl-1">Exportar gráfico</span>
                </v-btn>
              </template>

              <v-list class="py-4" dense>
                <v-list-item @click="printChart('chartEstimate')">
                  <span>Imprimir gráfico</span>
                </v-list-item>
                <v-list-item link @click="exportChart('image/png', 'chartEstimate')">
                  <v-list-item-content>
                    <span>Baixar imagem PNG</span>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item link @click="exportChart('image/jpeg', 'chartEstimate')">
                  <v-list-item-content>
                    <span>Baixar imagem JPEG</span>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item link @click="exportChart('image/svg+xml', 'chartEstimate')">
                  <v-list-item-content>
                    <span>Baixar imagem SVG</span>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item link @click="exportChart('application/pdf', 'chartEstimate')">
                  <v-list-item-content>
                    <span>Baixar documento PDF</span>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item link @click="exportCSV('chartEstimate')">
                  <v-list-item-content>
                    <span>Baixar documento CSV</span>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item link @click="exportXLS('chartEstimate')">
                  <v-list-item-content>
                    <span>Baixar documento XLS</span>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <v-card-text>
            <div id="chartCardGrantingEffluentsEstimate"></div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Highcharts from 'highcharts';
import exportingInit from 'highcharts/modules/exporting';
import offlineExporting from 'highcharts/modules/offline-exporting';
import accessibility from 'highcharts/modules/accessibility';
import EstimativaCarga from '@/api/priv/estimativa-carga.api'
import { mapGetters } from 'vuex';

exportingInit(Highcharts);
offlineExporting(Highcharts);
accessibility(Highcharts);

require('highcharts/modules/export-data')(Highcharts);
require('highcharts/modules/bullet')(Highcharts);
require('highcharts/modules/pattern-fill')(Highcharts);

export default {
  name: 'CardGrantingEffluentsChart',
  props: {
      location: {
          required: true,
      },
  },
  data: () => ({
    optionsList: [
      { id: 1, text: 'Atividade', value: 'ATIVIDADE' },
      { id: 2, text: 'Uso', value: 'USO' },
      { id: 3, text: 'Condição', value: 'CONDICAO' },
      { id: 4, text: 'Modalidade', value: 'MODALIDADE' },
    ],
    optionListSelected: { id: 3, text: 'Condição', value: 'CONDICAO' },
    chartCardGrantingEffluents: null,
    chartCardGrantingEffluentsEstimate: null,
    hasDataGrantingEffluentsDBO: false,
  }),
  computed: {
    ...mapGetters(['siaDetails'])
  },
  watch: {
    siaDetails(newVal, oldVal) {
      if (newVal?.locacronymn != oldVal?.locacronymn) {
        if (newVal.locacronymn) {
          this.loadDBO(newVal.locacronymn);
          this.outorgasEfluentesDBOById(newVal.locacronymn, this.optionListSelected.value);
        }
      }
    },
    async optionListSelected(val) {
      if (this.siaDetails) {
        await this.outorgasEfluentesDBOById(this.siaDetails.locacronymn, val.value);
      } else {
        await this.outorgasEfluentesDBOAll(val.value);
      }
    }
  },
  async mounted() {
    await this.initialize();
  },
  methods: {
    async initialize() {
      await this.outorgasEfluentesDBOAll(this.optionListSelected.value);
      await this.loadDBOAll();
    },

    createGrantingEffluentsChart(arrayData) {
      this.chartCardGrantingEffluents = Highcharts.chart(
        'chartCardGrantingEffluents',
        {
          chart: {
            type: 'column',
            backgroundColor: '#212A35',
            height: '350px',
            scrollablePlotArea: {
              // 40 seria um valor aceitavel pra largura de cada coluna da tabela
              // multiplicado pela quantidade de items dos dados
              minWidth: arrayData.length * 120,
              scrollPositionX: 0,
            },
          },
          title: {
            text: '',
          },
          credits: {
            enabled: false,
          },
          exporting: {
            enabled: false,
            sourceWidth: arrayData.length * 120,
            chartOptions: {
              title: {
                text: "Carga DBO Solicitada Diária (t/ano)",
                style:{
                  color: "#ffffff",
                  fontFamily: 'Roboto',
                  fontWeight: 700,
                  fontSize: '1rem',
                  lineHeight: '33px',
                },
              },
              subtitle: {
                text: this.location ? this.location.text : "Estado do Paraná",
                style:{
                  color: "#ffffff",
                  fontFamily: 'Roboto',
                  fontWeight: 600,
                  fontSize: '0.75rem',
                  lineHeight: '24px',
                },
              },
            }
          },
          xAxis: {
            type: 'category',
            labels: {
              style: {
                color: '#95A1EC',
                textTransform: 'uppercase',
              },
            },
            zIndex: 10,
          },
          yAxis: {
            title: {
              text: '',
            },
            gridLineColor: '#3A445D',
            gridLineDashStyle: 'Dash',
            labels: {
              formatter: function () {
                return Highcharts.numberFormat(this.value / 1000000, 0, '', '.') + ' Mi';
              },
              style: {
                color: '#95A1EC',
              },
            },
            zIndex: 2,
          },
          legend: {
            enabled: false,
          },
          plotOptions: {
            series: {
              borderRadius: 0,
              borderWidth: 0,
            },
          },
          tooltip: {
            style: {
              zIndex: 99999,
              maxWidth: 300,
            },
            headerFormat: '',
            stickOnContact: true,
            useHTML: true,
            pointFormatter: function() {
              const val = Highcharts.numberFormat(this.y, 0, '', '.');
              return `<strong style="color:${this.color}; z-index: 999;">${this.name.toLocaleUpperCase()} </strong>: <b>${val} t/ano</b><br/>`;
            },
            // pointFormat:
            //   '<strong style="color:{point.color}; z-index: 999;">{point.name}</strong>: <b>{point.y:.0f}</b><br/>',
          },
          colors: ['#95A1EC'],
          series: [
            {
              name: '',
              data: arrayData,
              dataLabels: {
                enabled: true,
                formatter: function() {
                  let val;
                  if (this.y > 1000000000) {
                    val = Highcharts.numberFormat(this.y / 1000000000, 0, '.', '.') + " Bi"
                  } else if (this.y > 1000000) {
                    val = Highcharts.numberFormat(this.y / 1000000, 0, '.', '.') + " Mi"
                  } else if (this.y > 1000) {
                    val = Highcharts.numberFormat(this.y / 1000, 0, '.', '.') + " Mil";
                  } else {
                    val = Highcharts.numberFormat(this.y, 0, '', '.');
                  }
                  return val;
                },
                rotation: 360,
                color: '#212A35',
                borderColor: '#212A35',
                align: 'center',
                y: 15, // 10 pixels down from the top
                style: {
                  fontSize: '14px',
                  fontFamily: 'Roboto',
                  fontWeight: 400,
                  fontStyle: 'normal',
                },
              },
            },
          ],
        },
      );
    },

    createGrantingEffluentsChartEstimate(arrayData) {
      this.chartCardGrantingEffluentsEstimate = Highcharts.chart(
        'chartCardGrantingEffluentsEstimate', {
          chart: {
            backgroundColor: '#212A35',
            type: 'pie',
            height: 300,
          },
          title: {
            text: '',
            style:{
              color: "#ffffff",
            },
          },
          subtitle: { text: null },
          credits: { enabled: false },
          exporting: {
            enabled: false,
            chartOptions: {
              title: {
                text: "Estimativa entre cargas DBO",
                style:{
                  color: "#ffffff",
                  fontFamily: 'Roboto',
                  fontWeight: 700,
                  fontSize: '1.1rem',
                  lineHeight: '33px',
                },
              },
              subtitle: {
                text: this.location ? this.location.text : "Estado do Paraná",
                style:{
                  color: "#ffffff",
                  fontFamily: 'Roboto',
                  fontWeight: 600,
                  fontSize: '0.75rem',
                  lineHeight: '24px',
                },
              },
            }
          },
          plotOptions: {
            pie: {
              borderWidth: 0,
              showInLegend: true,
              dataLabels: {
                enabled: true,
                format: '<br>{point.percentage:.1f} %',
                distance: -50,
                filter: {
                  property: 'percentage',
                  operator: '>',
                  value: 4,
                },
              },
            },
          },
          legend: {
            itemStyle: {
              color: '#D5D5D5',
              fontWeight: '400',
              fontFamily: 'Roboto',
            },
          },
          accessibility: {
            point: {
              valueSuffix: '%',
            },
          },
          tooltip: {
            headerFormat: '',
            pointFormat:
              '<strong style="color:{point.color}">{point.name}</strong>: <b>{point.y:.2f} kg/Ano</b><br/>',
          },
          series: [
            {
              innerSize: '30%',
              data: arrayData
            },
          ],
        },
      );
    },

    fullscreenChart(typeChart) {
      this.cIAlertChart.fullscreen.toggle();
      if (typeChart == 'chartEstimate') {
        this.chartCardGrantingEffluentsEstimate.fullscreen.toggle();
        return;
      }
      this.chartCardGrantingEffluents.fullscreen.toggle();
    },

    exportChart(typeFile, typeChart) {
      if (typeChart == 'chartEstimate') {
        this.chartCardGrantingEffluentsEstimate.exportChart({ type: typeFile });
        return;
      }
      this.chartCardGrantingEffluents.exportChart({ type: typeFile });
    },

    exportCSV(typeChart) {
      if (typeChart == 'chartEstimate') {
        this.chartCardGrantingEffluentsEstimate.downloadCSV();
        return;
      }
      this.chartCardGrantingEffluents.downloadCSV();
    },

    exportXLS(typeChart) {
      if (typeChart == 'chartEstimate') {
        this.chartCardGrantingEffluentsEstimate.downloadXLS();
        return;
      }
      this.chartCardGrantingEffluents.downloadXLS();
    },

    printChart(typeChart) {
      if (typeChart == 'chartEstimate') {
        this.chartCardGrantingEffluentsEstimate.print();
        return;
      }
      this.chartCardGrantingEffluents.print();
    },

    setItem(item) {
      this.optionListSelected = item;
    },

    async loadDBO(sia) {
      try {
        const payload = {
          sias: [sia]
        };

        const response = await EstimativaCarga.loadEstimativaCargaPieChart(payload);
        if (response.data && response.data.length > 0) {
          const values = response.data[0];
          this.createGrantingEffluentsChartEstimate(
            [
              {
                name: 'Difusa',
                y: values.dboDifusa || 0,
                color: '#CF4F57',
              },
              {
                name: 'Pontual',
                y: values.dboPontual || 0,
                color: '#2C8CB8',
              },
            ]
          );
          }
      } catch (error) {
        console.error(error)
      }
    },

    async loadDBOAll() {
      try {
        const response = await EstimativaCarga.loadEstimativaCargaPieChartAll();
        if (response.data && response.data.length > 0) {
          const values = response.data[0];
          this.createGrantingEffluentsChartEstimate(
            [
              {
                name: 'Difusa',
                y: values.dboDifusaSoma || 0,
                color: '#CF4F57',
              },
              {
                name: 'Pontual',
                y: values.dboPontualSoma || 0,
                color: '#2C8CB8',
              },
            ]
          );
        }
      } catch (error) {
        console.error(error)
      }
    },

    async outorgasEfluentesDBOAll(value) {
      try {
        const payload = {
          categoria: value
        }
        const response = await EstimativaCarga.outorgasEfluentesDBOAll(payload);
        if (response.data && response.data.length > 0) {
          this.hasDataGrantingEffluentsDBO = true;
          let chartData = response.data.map((e) => {
            return {
              name: e.descricao,
              y: e.soma
            }
          });
          chartData = chartData.sort((a, b) => b.y > a.y ? 1 : -1);
          this.createGrantingEffluentsChart(chartData);
        }
        else {
          this.hasDataGrantingEffluentsDBO = false;
        }
      } catch (error) {
        console.error(error)
      }
    },

    async outorgasEfluentesDBOById(sia, value) {
      try {
        const payload = {
          sias: [sia],
          categoria: value
        }
        const response = await EstimativaCarga.outorgasEfluentesDBO(payload)
        if (response.data && response.data.length > 0) {
          this.hasDataGrantingEffluentsDBO = true;
          let chartData = response.data.map((e) => {
            return {
              name: e.descricao,
              y: e.soma
            }
          });
          chartData = chartData.sort((a, b) => b.y > a.y ? 1 : -1);
          this.createGrantingEffluentsChart(chartData);
        }
        else {
          this.hasDataGrantingEffluentsDBO = false;
        }
      } catch (error) {
        console.error(error)
      }
    }
  },
};
</script>

<style scoped>
.text-title {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 1.3rem;
  line-height: 33px;
  color: #ffffff;
}
.text-title-card {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 1.2rem;
  line-height: 26px;
}
.text-export-card {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #95a1ec;
  text-transform: none;
  letter-spacing: normal;
}
.text-list-item {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 15px;
  color: #95a1ec;
}
.textNoData {
  color: #95A1EC;
  font-size: 18px;
  font-family: Roboto;
  font-style: italic;
  font-weight: 300;
  line-height: 20px;
}
/* width */
::-webkit-scrollbar {
  width: 4px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  /*padding-right-right: 1200px;*/
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: darkgrey;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: grey;
}
</style>
